import React from "react";
import { Card } from "antd";
import TotalPatientCharts from "./TotalPatientCharts";

const DashboardChart = ({graph, loading}) => {
  return (
    <Card className="h-full shadow-sm" loading={loading}>
      <div className="flex justify-between">
        <h1 className="font-bold text-lg">Total Patients</h1>
      </div>
      <TotalPatientCharts data={graph} loading={loading}/>
    </Card>
  );
};

export default DashboardChart;
